// AI Generated File
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'form-domain-groups-match-rule',
    templateUrl: './match-rule.component.html',
    standalone: false,
})
export class FormDomainGroupsMatchRuleComponent implements OnInit {
    @Input() matchOptions: any;
    @Input() rule: any;
    @Input() labels: any;
    @Input() key: any;
    @Output() onConfirmRemove = new EventEmitter<any>();
    @Output() onExcludeChange = new EventEmitter<void>();

    matchRulesOptions: any[] = [];
    matchExcludeOptions: any = [];

    constructor (private translateService: TranslateService) {}

    ngOnInit () {
        this.activate();
    }

    private activate () {
        this.setupMatchOptions();
        this.setupMatchRules();
        this.setupMatchExcludes();
    }

    private setupMatchOptions () {
        this.matchOptions = [
            {
                value: 'title',
                name: this.translateService.getString('title'),
            },
            {
                value: 'url',
                name: this.translateService.getString('path'),
            },
            {
                value: 'full_url',
                name: this.translateService.getString('url'),
            },
            {
                value: 'metadata',
                name: this.translateService.getString('metadata'),
            },
            {
                value: 'content',
                name: this.translateService.getString('content'),
            },
            {
                value: 'labels',
                name: this.translateService.getString('labels'),
            },
        ];
    }

    private setupMatchRules () {
        this.matchRulesOptions = [
            {
                value: 'contains',
                name: this.translateService.getString('contains'),
            },
            {
                value: 'starts_with',
                name: this.translateService.getString('starts_with'),
            },
            {
                value: 'ends_with',
                name: this.translateService.getString('ends_with'),
            },
            {
                value: 'is_exactly',
                name: this.translateService.getString('is_exactly'),
            },
            {
                value: 'regexp',
                name: this.translateService.getString('match (regex)'),
            },
        ];
    }

    private setupMatchExcludes () {
        this.matchExcludeOptions = [
            {
                value: false,
                name: this.translateService.getString('included'),
            },
            {
                value: true,
                name: this.translateService.getString('excluded'),
            },
        ];
    }

    handleConfirmRemove (rule: any) {
        this.onConfirmRemove.emit(rule);
    }

    handleExcludeChange () {
        this.onExcludeChange.emit();
    }
}
